export default {
  aggregates: {
    aggregated: '汇总结果',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: '前',
    from: '从',
    since: '自从',
    unit: {
      DAY: '天|天',
      MONTH: '月|月',
      YEAR: '年|年'
    },
    untilNow: '到目前为止'
  },
  categoryDetails: {
    average: '平均值为 {average}。{benchmark}',
    chartLabel: {
      noLabel: '不',
      yesLabel: '是的'
    },
    description: '这显示了团队对该类别中所有问题的回答是如何分布的。',
    hideOwnAnswers: '隐藏自己的答案',
    noResponses: '没有回复',
    notParticipating: '您本人还没有回答这些问题。',
    numberOfPeople: '受访者',
    sensitiveQuestion: '仅您作为经理可见。',
    showFollowUpQuestions: '显示后续问题',
    toggleButton: {
      overview: '概述',
      questions: '问题'
    },
    tooltip: {
      barValue: '没有人 | 1 人 | {count} 人',
      barValueAnswers: '0 个 | 1 个答案 | {count} 个答案'
    },
    workWith: '如何使用 {categoryName}',
    yourResponse: '您回复：'
  },
  error: {
    couldNotLoadAggregates: '无法加载聚合结果。',
    couldNotLoadResults: '无法加载结果。',
    networkError: '从 Internet 加载数据时出现问题。您的网络连接正常吗？',
    unknown: '出现未知错误'
  },
  errors: {
    status: {
      BadRequest: '服务器请求错误',
      Forbidden: '不允许访问此资源',
      InternalServerError: '服务器端出现问题，如果持续存在请联系支持人员',
      NotFound: '找不到您需要的内容',
      Unauthorized: '您无权访问此资源',
      UnknownError: '发生未知错误'
    }
  },
  freetext: {
    loadResponses: '加载回复',
    noFreeTextQuestions:
      '当您的调查中包含自由文本问题时，您将能在此查看所有回复。',
    notEnoughResponses: '回复数量不足。',
    responses: '无回复 | {count} 条回复 | {count} 条回复'
  },
  general: {
    add: '添加',
    cancel: '取消',
    entireOrganization: '整个组织',
    ok: '确定'
  },
  groupsComparison: {
    averageForItem: '{value} 是 {title} 中问题的平均分。{compareToBenchmark}',
    currentValue: '当前值',
    filter: {
      findGroups: '查找群组',
      shouldExportWithHierarchy: '包含下级群组'
    },
    loadMore: '加载更多',
    loadMoreInGroup: '加载更多 {groupName} 下的内容',
    noone: '无人回复',
    noResults: '此小组还没有足够的回复。{numberOfUsersThatHaveRespondedText}。',
    noResultsResponded: '已回复',
    nps: '净推荐者得分',
    nps_detractors: '贬低者',
    nps_passives: '被动者',
    nps_promoters: '推荐者',
    questions: '类别中的问题',
    showTrend: '显示变化',
    violationsIn:
      '报告表明 {groupName} 内发生了违规事件。请联系人力资源部，他们会告诉您更多信息，并帮助您继续解决这一问题。'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: '选择历史记录的起始日期。',
      selectDate: '将显示自 {date} 以来的调查历史记录。',
      selectedDate: '正在显示自 {date} 以来的调查历史记录。'
    },
    selectorOptions: {
      custom: '自定义',
      oneMonth: '1 个月',
      oneYear: '12 个月',
      sixMonths: '6 个月'
    }
  },
  loading: {
    error: {
      link: '再试一次'
    }
  },
  navbar: {
    administration: '管理员',
    currentSurveys: '当前调查',
    help: '帮助',
    myActivities: '操作',
    ourResults: '结果',
    overview: '概览',
    team: '团队',
    welcome: '欢迎'
  },
  page: {
    results: '所有结果'
  },
  resultDetails: {
    backToResults: '返回',
    exportData: '导出',
    exportModal: {
      includeSensitiveQuestions: '包括敏感问题',
      loadingMessage: '准备导出数据，这将需要一些时间。',
      saveAsExcelAllGroupsDescription:
        '导出到 Excel 将获取包含 {groupTitle} 及其所有下级群组结果的文件。 适用于需要进行多群组自主分析或计算的情况。',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        '导出到 Excel 将获取包含 {groupTitle}{segmentInfo} 结果的文件。 适用于需要进行自主分析或计算的情况。',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        '您将获得包含所选群组所有类别和问题结果的 PDF 文档。 适用于需要打印结果的情况。',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'PowerPoint 导出将为您生成包含 {groupTitle}{segmentInfo} 结果的精美演示文稿。 非常适合需要在大屏幕上向他人展示结果的情况。'
    },
    notes: {
      draggable: {
        explanation: '仅您可见',
        placeholder: '在此写下您自己对调查的笔记、评论和思考',
        title: '个人笔记'
      },
      status: {
        initial: '键入时自动保存',
        saved: '更改已保存！',
        unsaved: '即将保存...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses: '没有足够的响应来显示每个用户的结果'
        },
        description: {
          high: '有一人进行了回复，因此其平均分变成了绿色。|有 {count} 人进行了回复，因此他们的平均分变成了绿色。',
          low: '有一人进行了回复，因此其平均分变成了红色。|有 {count} 人进行了回复，因此他们的平均分变成了红色。',
          medium:
            '有一人进行了回复，因此其平均分变成了黄色。|有 {count} 人进行了回复，因此他们的平均分变成了黄色。'
        },
        title: '没有人 | 1 人 | {count} 人'
      },
      currentValue: {
        equalsToBenchmarkValue:
          '您的得分与 {title} 的 Pulsᐩ benchmark® 相同。',
        higherThanBenchmarkValue:
          '您的得分比 {title} 的 Pulsᐩ benchmark®（即 {benchmarkValue}）高出 {benchmarkDiff}。很好！',
        lowerThanBenchmarkValue:
          '您的得分比 {title} 的 Pulsᐩ benchmark®（即 {benchmarkValue}）低出 {benchmarkDiff}。',
        percentagePoints: '百分点'
      },
      enps: {
        button: {
          description:
            '您将被转到我们的合作伙伴 EQI，该公司收集了大量组织的基准数据，并提供有关您自己 eNPS 得分的更详细的见解。',
          title: '将您的 eNPS 分数与其他组织进行比较'
        }
      },
      toggleButton: {
        history: '历史记录',
        overview: '概览'
      }
    }
  },
  results: {
    aggregated: '汇总',
    chooseSurvey: '选择调查',
    finished: '已完成',
    published: '进行中'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI 使用生成式人工智能，可能会出错。',
    error: {
      generic: '哎呀……出现异常情况。 请尝试重新加载页面。',
      notEnoughResults:
        '没有结果可供讨论。 请选择其他群组或调查以使用 Pulsᐩ AI。'
    },
    moreInfo: '学习如何作为领导者使用 Pulsᐩ AI',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: '就结果提出问题……',
    reload: '重新加载页面',
    report: '报告问题',
    send: '发送',
    suggestionHeader: '以下是一些提问方面的建议：',
    suggestions: {
      groupsComparison: {
        1: '我应该关注哪些群体？',
        2: '大多数小组应该解决什么问题吗？',
        3: '哪些群体呈现负面趋势？',
        4: '哪些群体有积极的趋势？',
        5: '哪些群体表现不佳？',
        6: '哪些群体需要我的关注？',
        7: '我应该先做什么？'
      },
      overview: {
        1: '我该怎么处理我们的结果？',
        2: '我应该如何向我的团队介绍这个？',
        3: '总的来说，结果是什么样子？',
        4: '我们应该采取的三大行动是什么？',
        5: '我的领导能力可以改善什么？',
        6: '我们有什么风险？',
        7: '如果我们不采取行动会发生什么？',
        8: '我应该优先考虑什么？',
        9: '我的团队的预测是什么？'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: '每个人'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: '比较'
        },
        export: {
          title: '导出'
        },
        freetext: {
          title: '自由文本'
        },
        results: {
          title: '调查结果'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses: '无法在确保匿名性的前提下显示统计数据。',
    others: '其他 | 其他',
    tooltip: {
      barValue:
        '{numberOfPeople}\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\n          {segment}'
    }
  },
  sidebar: {
    administration: '管理',
    currentSurveys: '目前的调查',
    dashboard: '控制面板',
    help: '帮助',
    logOut: '登出',
    myActivities: '我的行动',
    ourResults: '我们的结果'
  },
  topbanner: {
    preview: {
      body: '您现在看到的是 Pulsᐩ 结果视图的新版本，它包含许多改进！ 如果您发现任何功能异常或有反馈意见，请告知我们！ 您也可以随时切换回旧版本。',
      header: '新版本！'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          '在 {startDate}-{endDate} 这段时间内，{categoryName} 的结果有所下降。',
        trend_increased:
          '在 {startDate}-{endDate} 这段时间内，{categoryName} 的结果有所增加。继续努力！',
        trend_same:
          '在 {startDate}-{endDate} 这段时间内，{categoryName} 的结果保持不变。'
      }
    },
    noTrend: '没有任何较旧的调查可以比较。',
    tag: {
      tooltip: {
        nps_trend_decreased:
          '与 {oldSurveyDate} 的上次调查相比，{tagName} 的结果降低了 {changeInPercent}%。',
        nps_trend_increased:
          '与 {oldSurveyDate} 的上次调查相比，{tagName} 的结果上升了 {changeInPercent}%。',
        nps_trend_same:
          '自 {oldSurveyDate} 的上次调查以来，{tagName} 的结果基本保持不变（变化 {changeInPercent}%）。',
        trend_decreased:
          '在 {startDate}-{endDate} 这段时间内，{tagName} 的结果有所下降。',
        trend_increased:
          '在 {startDate}-{endDate} 这段时间内，{tagName} 的结果有所增加',
        trend_same:
          '在 {startDate}-{endDate} 这段时间内，{categoryName} 的结果保持不变。'
      }
    }
  },
  utilityBar: {
    allGroups: '所有群组',
    cannotChangeGroupsWhileComparing:
      '在比较视图中，您可以同时查看多个群组的数据。',
    group: '群组',
    segment: '细分',
    survey: '调查'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction: '至少选择一项操作的人数',
      totalActions: '所选操作总数'
    },
    title: '行动摘要'
  },
  widgetAlert: {
    actions: {
      saved: '谢谢。该活动已保存。'
    },
    links: {
      tooltip: '链接在新窗口中打开'
    },
    notEnoughData: '目前这里没有任何内容可显示。'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: '最近报告于 {surveyDate}。'
      },
      question: {
        info: '最近于 {surveyDate} 在 "{surveyTitle}" 中询问。'
      }
    },
    notEnoughResponses: '还没有足够的回复来在此处显示任何内容。',
    title: '类别',
    tooltip: {
      value:
        '这是 {groupName} 中的人员对 {categoryName} 中问题的所有回答的平均值。'
    }
  },
  widgetErrorFallback: {
    description:
      '小部件加载时发生意外错误。 请先尝试重新加载页面。 如果问题仍然存在，请向我们报告，我们将立即处理！',
    hideErrorDetails: '隐藏错误详情',
    showErrorDetails: '显示错误详情',
    title: '小部件出现问题！'
  },
  widgetGroupActions: {
    allCategories: '在所有类别中',
    freeText: {
      alert: {
        noResults: '未找到任何内容。尝试输入其他内容。',
        typeMore: '再输入一些内容'
      },
      filterField: {
        placeholder: '输入以查找评论'
      },
      numberOfComments: '{numberOfComments} 评论'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: '如何在员工中培养个人责任感'
      }
    },
    noActions: '没有可显示的操作。',
    noActionsSelectedInCategory: '没有选择任何操作',
    otherActions: '自己的行动',
    people: '没有人 | {count} 个人 | {count} 个人',
    peopleSelectedActions:
      '在已回复的 {peopleResponded} 个人中，只有 1 人选择了至少一项行动 ({percentage}%)|在已回复的 {peopleResponded} 个人中，{count} 人选择了至少一项行动 ({percentage}%)',
    title: '选择 {groupName} 中人员的行动',
    tooltip: {
      numberOfPeopleChoseActions: '1 人选择了此操作| {count} 人选择了此操作'
    }
  },
  widgetGroupPriorities: {
    description: '调查参与者表示，这些是目前最需要关注的领域。',
    freeTextResponses: '显示自由文本回复',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: '如何使用 Pulsᐩ 发展您的团队'
      }
    },
    noPriorities: '参与者没有选择优先事项。',
    people: '没有人 | {count} 个人 | {count} 个人',
    thinkImportant: ' 认为“{category}”最重要',
    title: '人们的优先事项 {groupName}'
  },
  widgetNotImplemented: {
    content: '尚未实施'
  },
  widgetSurveyInfo: {
    endDate: '结束日期',
    noone: '无人回复',
    notEnoughResponses: {
      aggregate: '该时间段内回复人数不足，无法显示结果。',
      completed: '调查回复人数不足，无法显示结果。',
      published: '目前调查回复人数不足，无法显示结果。'
    },
    participation: {
      title: '参与情况'
    },
    startDate: '开始日期',
    status: {
      completed: '调查完成！这些是最终结果。',
      published: '调查仍在进行中。结果是初步的。'
    },
    usersInvited: '受邀人员',
    usersResponded: '已回复的人员'
  },
  widgetTagsDonuts: {
    description: {
      all: '这些是 {groupName} 的最新结果。'
    },
    notEnoughResponses: '还没有足够的回复来在此处显示任何内容。',
    title: {
      company: '所有的 {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS 是 Employee Net Promoter Score（员工净推荐者得分）的缩写，用于衡量员工向别人推荐在其公司工作的意愿。',
      nps_description: 'NPS 表示净推荐值，衡量人们向他人推荐某物的可能性。',
      nps_detractors: '贬低者',
      nps_passives: '被动者',
      nps_promoters: '推荐者',
      value: '这是 {groupName} 中的人员对 {tagName} 中问题的所有回答的平均值。'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} 随着时间的推移',
    twoTags: '{tag1} 和 {tag2}'
  }
}
